module.exports = __webpack_public_path__ + "img/hide-english-two.0e472530.png";